/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITumor } from 'app/shared/model/tumor.model';
import { ITreatmentRegimen } from 'app/shared/model/treatment-regimen.model';

export interface ITreatmentTumor {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  tumor?: ITumor | null;
  regimen?: ITreatmentRegimen | null;
}

export const defaultValue: Readonly<ITreatmentTumor> = {
  active: false,
};
